import { useEffect } from "react";
import { FaBook, FaBookOpen, FaFilePdf, FaFolderOpen, FaTasks } from "react-icons/fa";
import { LIBRARY_CONSTANTS } from "../../_Library/_MODULES/_API";
import { MANUALS_CONSTANTS } from "../../_Manuals/_MODULES/_API";
import { COURSES_CONSTANTS } from "../../_Courses/_MODULES/_API";
import { PageHeader } from "../../../../../_CORE/APP/Templates/_UI/PageHeader/_index";
import { AppButton } from "../../../../../_CORE/APP/Templates/_UI/Button/_index";
import { MetricCard, MetricGrid } from "../../../../../_CORE/APP/Templates/_UI/Metrics/_index";
import { useApiQuery } from "../../../../../_CORE/APP/Hooks/Hooks/_Records/_useApiQuery";
import { ViewLayout } from "../../../../_UI/ViewLayout";
import "../_UI/_Styles/WorkspaceDashboard.css";

export const ShelfDashboardViewMain = () => {
    const libraryGroupsQuery = useApiQuery({ minTimeQuery: 180, enablePagination: false, startLoading: true });
    const libraryDocumentsQuery = useApiQuery({ minTimeQuery: 180, enablePagination: false, startLoading: true });
    const manualsQuery = useApiQuery({ minTimeQuery: 180, enablePagination: false, startLoading: true });
    const coursesQuery = useApiQuery({ minTimeQuery: 180, enablePagination: false, startLoading: true });

    useEffect(() => {
        libraryGroupsQuery.apiGet({ endpoint: LIBRARY_CONSTANTS.GROUP_LIST });
        libraryDocumentsQuery.apiGet({ endpoint: LIBRARY_CONSTANTS.PDF_LIST });
        manualsQuery.apiGet({ endpoint: MANUALS_CONSTANTS.LIST });
        coursesQuery.apiGet({ endpoint: COURSES_CONSTANTS.LIST });
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const groups = Array.isArray(libraryGroupsQuery.useApiData) ? libraryGroupsQuery.useApiData : [];
    const documents = Array.isArray(libraryDocumentsQuery.useApiData) ? libraryDocumentsQuery.useApiData : [];
    const manuals = Array.isArray(manualsQuery.useApiData) ? manualsQuery.useApiData : [];
    const courses = Array.isArray(coursesQuery.useApiData) ? coursesQuery.useApiData : [];

    const manualPages = manuals.reduce((total, manual) => total + Number(manual.pageCount || manual.pages?.length || 0), 0);
    const pendingCourseTasks = courses.reduce((total, course) => total + Number(course.pendingTaskCount || 0), 0);
    const isLoading = libraryGroupsQuery.useApiLoading || libraryDocumentsQuery.useApiLoading || manualsQuery.useApiLoading || coursesQuery.useApiLoading;

    return (
        <ViewLayout
            header={
                <PageHeader
                    title="Estantería"
                    description="Tu espacio de lectura, documentación, manuales y cursos, organizado desde un único panel."
                    icon={<FaBookOpen />}
                    actions={
                        <div className="LStudio__workspace_dashboard_actions">
                            <AppButton to="/library" variant="outline" tone="neutral" icon={<FaFilePdf />}>Biblioteca</AppButton>
                            <AppButton to="/manuals" icon={<FaBook />}>Manuales</AppButton>
                        </div>
                    }
                />
            }
        >
            <section className="LStudio__workspace_dashboard_section">
                <div className="LStudio__workspace_dashboard_heading">
                    <span>Panel de estantería</span>
                    <small>Resumen de todo el material que guardás para consultar, estudiar o documentar.</small>
                </div>

                <MetricGrid columns="auto">
                    <MetricCard label="PDF" value={documents.length} icon={<FaFilePdf />} tone="accent" isLoading={isLoading} to="/library" />
                    <MetricCard label="Grupos de biblioteca" value={groups.length} icon={<FaFolderOpen />} tone="neutral" isLoading={isLoading} />
                    <MetricCard label="Manuales" value={manuals.length} icon={<FaBook />} tone="accent" isLoading={isLoading} to="/manuals" footer={`${manualPages} páginas registradas`} />
                    <MetricCard label="Cursos" value={courses.length} icon={<FaBookOpen />} tone="neutral" isLoading={isLoading} to="/courses" footer={`${pendingCourseTasks} tareas pendientes`} />
                    <MetricCard label="Material total" value={documents.length + manuals.length + courses.length} icon={<FaTasks />} tone="neutral" isLoading={isLoading} footer="PDF, manuales y cursos" />
                </MetricGrid>
            </section>
        </ViewLayout>
    );
};
